export const baseURL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : 'http://localhost:4000';
export const DATETIME_FORMAT = 'MM/DD/YYYY HH:mm:ss';
export const DATE_FORMAT = 'MM/DD/YYYY';
export const STREAM_APP_TOKEN = 'N3vdQjFBaZN5XztLlG6Cixq1pJn0T9Vw';
